import React, { useMemo, useCallback, useState, useEffect } from 'react';
import { toast } from 'react-toastify';

import { LinearProgress } from '@material-ui/core';
import { isArray } from 'lodash';
import moment from 'moment';

import { t } from '~/helpers';
import api from '~/services/api';

import Header from './components/Header';
import Table from './components/Table';
import * as S from './styles';

function ResumoSLA() {
  const [loading, setLoading] = useState(true);
  const [dataTable, setDataTable] = useState([]);
  const [d1, setD1] = useState('');
  const [mes, setMes] = useState('');
  const [ano, setAno] = useState('');

  const header = useMemo(() => {
    const agora = moment();

    return {
      iniciomes: agora.clone().startOf('month').format('DD/MM/YYYY 00:00:00'),
      inicioano: moment({ year: agora.year(), month: 0, day: 1 }).format(
        'DD/MM/YYYY 00:00:00'
      ),
    };
  }, []);

  const handleSubmitHeader = useCallback(async ({ iniciomes, inicioano }) => {
    try {
      setLoading(true);
      const { data } = await api.get('pitstop/indicadoroperacaoresumosla', {
        params: {
          datahorainiciomes: moment(iniciomes, 'DD/MM/YYYY').format(
            'YYYY-MM-DD 00:00:00'
          ),
          datahorainicioano: moment(inicioano, 'DD/MM/YYYY').format(
            'YYYY-MM-DD 00:00:00'
          ),
        },
      });

      setD1(moment().subtract(1, 'day').format('DD/MM/YYYY'));
      setMes(moment(iniciomes, 'DD/MM/YYYY').format('MM/YYYY'));
      setAno(moment(inicioano, 'DD/MM/YYYY').format('YYYY'));
      setDataTable(data);
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    } finally {
      setLoading(false);
    }
  });

  return (
    <S.Wrapper>
      {loading && <LinearProgress />}
      <Header data={header} handleSubmit={handleSubmitHeader} />

      <Table d1={d1} mes={mes} ano={ano} data={dataTable} />
    </S.Wrapper>
  );
}

export default ResumoSLA;
